import { joinUrl } from '@root/src/lib/joinUrl';
function checkForErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText ||
            `getIdApiUserData | An api call returned HTTP status ${response.status}`);
    }
    return response;
}
const callApi = (url) => {
    return fetch(url, {
        credentials: 'include',
    })
        .then(checkForErrors)
        .then((response) => response.json());
};
const cache = {};
export const getIdApiUserData = (ajaxUrl) => {
    if (!(ajaxUrl in cache)) {
        const url = joinUrl([ajaxUrl, 'user/me']);
        const response = callApi(url);
        cache[ajaxUrl] = response;
    }
    return cache[ajaxUrl];
};
